import LotMap from "./lib/components/lot-map.js"

import './modal-gallery-v2';

/**
 * This class is used with CommunitySitemap widget
 */
class CommunitySitemap {
    /**
     * @param moduleSelector jQuery selector pointing to the root element of this CommunitySitemap module
     */
    constructor(moduleSelector) {
        this.moduleElem = $(moduleSelector);
    }

    /**
     * Handles initialization the Community Sitemap module
     */
    init() {
        lozadObserver();

        // Attempt to init the LOT MAP if exists
        var lotMapElem = this.moduleElem.find(".lotmap");

        if (lotMapElem.length > 0) {
            console.log("CommunitySitemap initializing lot map...");
            var lotMap = new LotMap(lotMapElem);
            lotMap.init();
        }
        
    }
}

window.CommunitySitemap = CommunitySitemap;